import { A as AirDatepicker, l as localeEs, getLocaleByLanguage } from './es.js';
import { language } from '../old/language.js';

//document.addEventListener("DOMContentLoaded", () => {
export async function initReservePicker() {

  // Función auxiliar para obtener traducciones
  const getTranslation = (key) => {
    const languageId = typeof Liferay !== 'undefined'
      ? Liferay.ThemeDisplay.getLanguageId()
      : 'es_ES';
    return language[key]?.[languageId] || language[key]?.['es_ES'] || key;
  };

  new AirDatepicker("#date-range-redesing", {
    classes: "date-picker-viva range-picker-reserve",
    locale: getLocaleByLanguage(),
    range: true,
    multipleDatesSeparator: " - ",
    container: "#reserveCard22",
    autoClose: false,
    minDate: /* @__PURE__ */ new Date(),
    inline: false,
    navTitles: {
      days: "<strong>MMMM</strong>"
    },
    toggleSelected: false,
    buttons: [
      {
        content: getTranslation("confirmar-fechas"),
        className: "btn-picker-custom !p-2 text-neutral-000 hover:bg-viva-orange-600 hover:text-neutral-0 transition-colors duration-300",
        onClick: (dp) => {
          dp.hide();
          innerClickReserveFrame;
        }
      }
    ],
    onShow: () => {
      if (!eventRangePickerReserveApplied) {
        applyEventRangePickerReserve();
      }
      const reserve = document.querySelector(
        ".range-picker-reserve"
      );
      const parentElement = document.getElementById("parentElementoPicker");
      if (parentElement && reserve) {
        reserve.style.width = `${parentElement.clientWidth}px`;
        reserve.style.left = `${parentElement.offsetLeft}px`;
        if (parentElement.offsetLeft == 8) {
          reserve.style.left = `${parentElement.offsetLeft + 13}px`;
        }
      }
    }
  });
  let innerClickReserveFrame = false;
  let eventRangePickerReserveApplied = false;
  const reserveFrameCardViva = document.getElementById("reserveFrameCardViva");
  const reserveCardContainer = document.getElementById("reserveCardContainer");
  if (reserveFrameCardViva) {
    reserveFrameCardViva.addEventListener("click", () => {
      innerClickReserveFrame = true;
      if (reserveCardContainer) {
        reserveCardContainer.classList.add("active");
        loadHeightMoreInfoReserveCard();
        loadReserveStylesMobileOpen();
        //otra posible causa
      }
    });
  }
  if (reserveCardContainer) {
    reserveCardContainer.addEventListener("click", () => {
      if (!innerClickReserveFrame) {
        reserveCardContainer.classList.remove("active");
        const huespedesContainer2 = document.getElementById("huespedesContainer");
        if (huespedesContainer2) {
          const selectInputContainer = document.querySelector(
            ".huespedes-select-container"
          );
          if (huespedesContainer2.classList.contains("active")) {
            huespedesContainer2.setAttribute("style", "height: 0px;");
            setTimeout(() => {
              selectInputContainer?.classList.remove("active");
              huespedesContainer2.classList.remove("active");
            }, 100);
          }
        }
        const hotelReservaSelectContainer = document.querySelector(
          ".hotel-reserva-select-container"
        );
        const hotelReservaSelectList = document.querySelector(
          ".hotel-reserva-select-list"
        );
        hotelReservaSelectList?.setAttribute("style", "height: 0px;");
        setTimeout(() => {
          hotelReservaSelectList?.classList.remove("active");
          hotelReservaSelectContainer?.classList.remove("active");
        }, 100);
        removeHeightMoreInfoReserveCard();
        loadReserveStylesMobile();
        loadTabletStyles();
      } else {
        innerClickReserveFrame = false;
      }
    });
  }
  if (reserveCardContainer) {
    reserveCardContainer.addEventListener("mouseenter", () => {
      loadHeightMoreInfoReserveCard();
    });
    reserveCardContainer.addEventListener("mouseleave", () => {
      removeHeightMoreInfoReserveCard();
    });
  }
  const applyEventRangePickerReserve = () => {
    const rangePickerReserve = document.querySelector(".range-picker-reserve");
    rangePickerReserve?.addEventListener("click", (e) => {
      e.stopPropagation();
      innerClickReserveFrame = true;
    });
    eventRangePickerReserveApplied = true;
  };
  const huespedesContainer = document.getElementById("huespedesContainer");
  huespedesContainer?.addEventListener("click", (e) => {
    e.stopPropagation();
    innerClickReserveFrame = true;
  });
  const containerHotelReservaSelect = document.querySelector(
    ".container-hotel-reserva-select"
  );
  containerHotelReservaSelect?.addEventListener("click", (e) => {
    const containerSelect = document.querySelector(
      ".container-huespedes-reserva-select"
    );
    if (containerSelect) {
      applyRemoveSelectExpandHuespedes(containerSelect);
    }
  });
  const containerHuespedesReservaSelect = document.querySelector(
    ".container-huespedes-reserva-select"
  );
  containerHuespedesReservaSelect?.addEventListener("click", (e) => {
    const containerSelect = document.querySelector(
      ".container-hotel-reserva-select"
    );
    if (containerSelect) {
      applyRemoveSelectExpandHotel(containerSelect);
    }
  });
  const contenedorCodigoDescuento = document.querySelector(
    ".contenedor-codigo-descuento"
  );
  contenedorCodigoDescuento?.addEventListener("click", (e) => {
    const containerSelect = document.querySelector(
      ".container-huespedes-reserva-select"
    );
    if (containerSelect) {
      applyRemoveSelectExpandHuespedes(containerSelect);
    }
    const containerSelectHotel = document.querySelector(
      ".container-hotel-reserva-select"
    );
    if (containerSelectHotel) {
      applyRemoveSelectExpandHotel(containerSelectHotel);
    }
  });
  const elementoPickerDate = document.getElementById("parentElementoPicker");
  elementoPickerDate?.addEventListener("click", (e) => {
    const containerSelect = document.querySelector(
      ".container-huespedes-reserva-select"
    );
    if (containerSelect) {
      applyRemoveSelectExpandHuespedes(containerSelect);
    }
    const containerSelectHotel = document.querySelector(
      ".container-hotel-reserva-select"
    );
    if (containerSelectHotel) {
      applyRemoveSelectExpandHotel(containerSelectHotel);
    }
  });
  const applyRemoveSelectExpandHuespedes = (containerSelect) => {
    const selectItems = containerSelect.querySelector(
      ".select-items-input-inner-viva"
    );
    const selectInputContainer = containerSelect.querySelector(
      ".input-inner-select-viva-container"
    );
    if (window.innerWidth < 1024) return;
    if (selectItems?.classList.contains("active")) {
      selectItems.setAttribute("style", "height: 0px;");
      setTimeout(() => {
        selectInputContainer?.classList.remove("active");
        selectItems.classList.remove("active");
      }, 100);
    }
  };
  const applyRemoveSelectExpandHotel = (containerSelect) => {
    const selectItems = containerSelect.querySelector(".select-items-viva");
    const selectInputContainer = containerSelect.querySelector(
      ".select-input-viva-container"
    );
    if (window.innerWidth < 1024) return;
    if (selectItems?.classList.contains("active")) {
      selectItems.setAttribute("style", "height: 0px;");
      setTimeout(() => {
        selectInputContainer?.classList.remove("active");
        selectItems.classList.remove("active");
      }, 100);
    }
  };
  // const childrenButtonAdd = document.getElementById("childrenButtonAdd");
  // const childrenButtonSubstract = document.getElementById(
  //   "childrenButtonSubstract"
  // );
  // const childrenInput = document.getElementById("childrenInput");
  // childrenButtonAdd?.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   huespedesContainer?.setAttribute(
  //     "style",
  //     `height: ${huespedesContainer?.clientHeight + 52}px;`
  //   );
  //   const nodeAgeKidInput = document.querySelector(".ageKidInputHidden");
  //   const kidsAgesContainer = document.getElementById("kidsAgesContainer");
  //   if (nodeAgeKidInput && kidsAgesContainer) {
  //     const newNode = nodeAgeKidInput.cloneNode(true);
  //     newNode.classList.remove("hidden", "ageKidInputHidden");
  //     newNode.setAttribute(
  //       "placeholder",
  //       `Edad niño ${kidsAgesContainer.childElementCount + 1}`
  //     );
  //     newNode.setAttribute(
  //       "id",
  //       `ageKidInput${kidsAgesContainer.childElementCount + 1}`
  //     );
  //     kidsAgesContainer.appendChild(newNode);
  //     if (childrenInput) {
  //       const currentValue = parseInt(
  //         childrenInput.getAttribute("value") || "0",
  //         10
  //       );
  //       childrenInput.setAttribute("value", (currentValue + 1).toString());
  //     }
  //   }
  // });
  // childrenButtonSubstract?.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   if (childrenInput) {
  //     console.log(childrenInput.getAttribute("value"));
  //     if (childrenInput.getAttribute("value") === "" || childrenInput.getAttribute("value") === "0" || childrenInput.getAttribute("value") === null) {
  //       return;
  //     }
  //     const currentValue = parseInt(
  //       childrenInput.getAttribute("value") || "0",
  //       10
  //     );
  //     huespedesContainer?.setAttribute(
  //       "style",
  //       `height: ${huespedesContainer?.clientHeight - 52}px;`
  //     );
  //     const kidsAgesContainer = document.getElementById("kidsAgesContainer");
  //     if (kidsAgesContainer?.childElementCount && kidsAgesContainer.childElementCount > 0) {
  //       kidsAgesContainer.removeChild(
  //         kidsAgesContainer.lastElementChild
  //       );
  //       if (childrenInput) {
  //         if (currentValue == 1) {
  //           childrenInput.setAttribute("value", "");
  //         } else {
  //           childrenInput.setAttribute("value", (currentValue - 1).toString());
  //         }
  //       }
  //     }
  //   }
  // });
  const adultsInput = document.getElementById("adultsInput");
  const adultsButtonAdd = document.getElementById("adultsButtonAdd");
  const adultsButtonSubstract = document.getElementById(
    "adultsButtonSubstract"
  );
  // adultsButtonAdd?.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   if (adultsInput) {
  //     const currentValue = parseInt(
  //       adultsInput.getAttribute("value") || "0",
  //       10
  //     );
  //     adultsInput.setAttribute("value", (currentValue + 1).toString());
  //   }
  // });
  // adultsButtonSubstract?.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   if (adultsInput) {
  //     const currentValue = parseInt(
  //       adultsInput.getAttribute("value") || "0",
  //       10
  //     );
  //     if (currentValue > 0) {
  //       const valueToSet = currentValue - 1;
  //       if (valueToSet == 0) {
  //         adultsInput.setAttribute("value", "");
  //       } else {
  //         adultsInput.setAttribute("value", valueToSet.toString());
  //       }
  //     }
  //   }
  // });
  // const btnConfirmGuests = document.getElementById("btnConfirmGuests");
  // btnConfirmGuests?.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   if (huespedesContainer) {
  //     huespedesContainer.setAttribute("style", "height: 0px;");
  //     const selectInputContainer = document.querySelector(
  //       ".huespedes-select-container"
  //     );
  //     selectInputContainer?.classList.remove("active");
  //     huespedesContainer.classList.remove("active");
  //     const huespedesReservasSelect = document.getElementById(
  //       "huespedes-reserva-select"
  //     );
  //     const adultsValue = parseInt(
  //       adultsInput?.getAttribute("value") || "0",
  //       10
  //     );
  //     const childrenValue = parseInt(
  //       childrenInput?.getAttribute("value") || "0",
  //       10
  //     );
  //     if (adultsValue == 0) {
  //       huespedesReservasSelect?.setAttribute("value", ``);
  //       return;
  //     }
  //     if (huespedesReservasSelect) {
  //       if (childrenValue > 0) {
  //         huespedesReservasSelect.setAttribute(
  //           "value",
  //           `${adultsValue} Adultos, ${childrenValue} Niños`
  //         );
  //       } else {
  //         huespedesReservasSelect.setAttribute(
  //           "value",
  //           `${adultsValue} Adultos`
  //         );
  //       }
  //     }
  //   }
  // });
  const loadHeightMoreInfoReserveCard = () => {
    const moreInfoReserveCard = document.querySelector(
      ".more-info-reserve-card"
    );
    if (moreInfoReserveCard) {
      if (innerWidth < 1536) {
        if (innerWidth < 1024) {
          moreInfoReserveCard.setAttribute(
            "style",
            "min-height: 98px; opacity: 1;"
          );
        } else {
          moreInfoReserveCard.setAttribute("style", "height: auto;");
          const heightMoreInfo = moreInfoReserveCard.clientHeight;
          moreInfoReserveCard.setAttribute(
            "style",
            `height: ${heightMoreInfo}px; opacity: 1;`
          );
        }
      } else {
        moreInfoReserveCard.setAttribute("style", 'height: auto; opacity: 1;');
        //            'height: auto; opacity: 1;' "height: 88px; opacity: 1;"
      }
    }
  };
  const removeHeightMoreInfoReserveCard = () => {
    const moreInfoReserveCard = document.querySelector(
      ".more-info-reserve-card"
    );
    if (moreInfoReserveCard) {
      moreInfoReserveCard.setAttribute("style", "height: 0px; opacity: 0;");
    }
  };
  const loadReserveStylesMobile = () => {
    const widthWindow = window.innerWidth;
    if (widthWindow < 744) {
      const inputsReserveContainer = document.getElementById(
        "inputsReserveContainer"
      );
      if (inputsReserveContainer) {
        inputsReserveContainer.classList.add("flex-col");
        inputsReserveContainer.classList.remove("flex-row");
        inputsReserveContainer.setAttribute("style", "display: none;");
        //puede ser causado por esto
        //o esto collapse-mode
      }
      const moreInfoReserveCard = document.querySelector(
        ".more-info-reserve-card"
      );
      if (moreInfoReserveCard) {
        moreInfoReserveCard.classList.add("mobile-version");
      }
      const reserveFrameCardViva2 = document.getElementById(
        "reserveFrameCardViva"
      );
      if (reserveFrameCardViva2) {
        if (reserveFrameCardViva2.classList.contains("rounded-lg")) {
          reserveFrameCardViva2.classList.remove("rounded-lg");
          reserveFrameCardViva2.classList.add("rounded-full");
        }
      }
    }
  };
  const removeReserveStylesMobile = () => {
    const inputsReserveContainer = document.getElementById(
      "inputsReserveContainer"
    );
    if (inputsReserveContainer) {
      inputsReserveContainer.classList.remove("flex-col");
      inputsReserveContainer.classList.add("flex-row");
      inputsReserveContainer.removeAttribute("style");
    }
    const moreInfoReserveCard = document.querySelector(
      ".more-info-reserve-card"
    );
    if (moreInfoReserveCard) {
      moreInfoReserveCard.classList.remove("mobile-version");
    }
  };
  const loadReserveStylesMobileOpen = () => {
    const widthWindow = window.innerWidth;
    if (!(widthWindow < 1024)) {
      return;
    }
    const inputsReserveContainer = document.getElementById(
      "inputsReserveContainer"
    );
    if (inputsReserveContainer) {
      inputsReserveContainer.removeAttribute("style");
      if (!(widthWindow < 744)) {
        const moreInfoReserveCard = document.querySelector(
          ".more-info-reserve-card"
        );
        inputsReserveContainer.classList.remove("tablet-version");
        inputsReserveContainer.classList.remove("flex-row");
        inputsReserveContainer.classList.add("flex-col");
        moreInfoReserveCard?.classList.add("mobile-version");
      }
      const selectsInput = inputsReserveContainer.querySelectorAll(".select-input-viva");
      selectsInput.forEach((select) => {
        const selectInputContainer = select.querySelector(
          ".select-input-viva-container"
        );
        selectInputContainer?.setAttribute("style", "height: 56px;");
        const selectInputList = select.querySelector(".select-items-viva");
        selectInputList?.classList.remove("absolute");
        selectInputList?.classList.add("collapse-mode");
      });
      const selectsInnerInput = inputsReserveContainer.querySelectorAll(
        ".input-inner-select-viva"
      );
      selectsInnerInput.forEach((select) => {
        const selectInputContainer = select.querySelector(
          ".input-inner-select-viva-container"
        );
        selectInputContainer?.setAttribute("style", "height: 56px;");
        const selectInputList = select.querySelector(
          ".select-items-input-inner-viva"
        );
        selectInputList?.classList.remove("absolute");
        selectInputList?.classList.add("collapse-mode");
      });
    }
    const reserveFrameCardViva2 = document.getElementById(
      "reserveFrameCardViva"
    );
    if (reserveFrameCardViva2) {
      reserveFrameCardViva2.setAttribute(
        "style",
        "flex-direction: column; height: auto;"
      );
      reserveFrameCardViva2.classList.remove("rounded-full");
      reserveFrameCardViva2.classList.add("rounded-lg");
      const moreInfoReserveCardItems = document.querySelectorAll(
        ".more-info-reserve-card-item"
      );
      moreInfoReserveCardItems.forEach((item) => {
        item.setAttribute("style", "display: none;");
      });

      //otro posible culpable
      const reserveCard = document.querySelector(".reserve-card");
      if (reserveCard) {
        reserveCard.classList.add("reserve-card-mobile");
      }
    }
  };
  const removeReserveStylesMobileOpen = () => {
    const inputsReserveContainer = document.getElementById(
      "inputsReserveContainer"
    );
    if (inputsReserveContainer) {
      inputsReserveContainer.removeAttribute("style");
      const selectsInput = inputsReserveContainer.querySelectorAll(".select-input-viva");
      selectsInput.forEach((select) => {
        const selectInputContainer = select.querySelector(
          ".select-input-viva-container"
        );
        selectInputContainer?.removeAttribute("style");
        const selectInputList = select.querySelector(".select-items-viva");
        selectInputList?.classList.add("absolute");
        selectInputList?.classList.remove("collapse-mode");
      });
      const selectsInnerInput = inputsReserveContainer.querySelectorAll(
        ".input-inner-select-viva"
      );
      selectsInnerInput.forEach((select) => {
        const selectInputContainer = select.querySelector(
          ".input-inner-select-viva-container"
        );
        selectInputContainer?.removeAttribute("style");
        const selectInputList = select.querySelector(
          ".select-items-input-inner-viva"
        );
        selectInputList?.classList.add("absolute");
        selectInputList?.classList.remove("collapse-mode");
      });
    }
    const reserveFrameCardViva2 = document.getElementById(
      "reserveFrameCardViva"
    );
    if (reserveFrameCardViva2) {
      reserveFrameCardViva2.removeAttribute("style");
      reserveFrameCardViva2.classList.add("rounded-full");
      reserveFrameCardViva2.classList.remove("rounded-lg");
      const moreInfoReserveCardItems = document.querySelectorAll(
        ".more-info-reserve-card-item"
      );
      moreInfoReserveCardItems.forEach((item) => {
        item.removeAttribute("style");
      });
      const reserveCard = document.querySelector(".reserve-card");
      if (reserveCard) {
        reserveCard.classList.remove("reserve-card-mobile");
      }
    }
  };
  const loadTabletStyles = () => {
    const windowWidth = window.innerWidth;
    const inputsReserveContainer = document.getElementById(
      "inputsReserveContainer"
    );
    if (!(windowWidth >= 744 && windowWidth < 1180)) {
      if (inputsReserveContainer) {
        inputsReserveContainer.classList.remove("tablet-version");
      }
      return;
    }
    const reserveFrameCardViva2 = document.getElementById(
      "reserveFrameCardViva"
    );
    reserveFrameCardViva2?.removeAttribute("style");
    reserveFrameCardViva2?.classList.remove("rounded-lg");
    reserveFrameCardViva2?.classList.add("rounded-full");
    if (inputsReserveContainer) {
      inputsReserveContainer.classList.add("tablet-version");
    }
  };
  const applyResponsiveStyles = () => {
    const widthWindow = window.innerWidth;
    loadTabletStyles();
    if (widthWindow < 744) {
      loadReserveStylesMobileOpen();
      loadReserveStylesMobile();
    } else {
      removeReserveStylesMobile();
      removeReserveStylesMobileOpen();
    }
  };

  const smallScreenQuery = window.matchMedia("(max-width: 743px)");
  const tabletScreenQuery = window.matchMedia("(min-width: 744px) and (max-width: 1179px)");
  const largeScreenQuery = window.matchMedia("(min-width: 1180px)");

  smallScreenQuery.addEventListener("change", applyResponsiveStyles);
  tabletScreenQuery.addEventListener("change", applyResponsiveStyles);
  largeScreenQuery.addEventListener("change", applyResponsiveStyles);

  applyResponsiveStyles();
}
//)